export const facialRecognition = {
  'After finishing it, return to this page':
    'Después de terminarlo, volvé a esta página',
  'Click the link below to perform the facial authentication procedure':
    'Hacé clic en el enlace de abajo para realizar el procedimiento de reconocimiento facial.',
  'Facial recognition': 'Reconocimiento facial',
  'Make sure your face is the only one appearing in the photo':
    'Asegúrese de que su rostro sea el único en aparecer en la foto',
  'Move to a well-lit place': 'Ubicate en un lugar iluminado',
  'Please, choose how you want to identify yourself':
    'Por favor, elija cómo desea identificarse',
  'Perform authentication': 'Realizar autenticación',
  'Remove glasses or hats': 'Quitate los anteojos o sombrero y volvés',
  'The background should be neutral For instance, stay in from of a bright wall':
    'El fondo debe ser neutro. Por ejemplo, colóquese frente a una pared clara.',
  'The process is fast and you only need to pass through it once for this process':
    'El proceso es rápido y solo necesitás hacerlo una vez para este proceso',
  'The selfie should be taken by the service taker customer (or by its legal guardian, in case of a minor)':
    'La selfie debe ser tomada por el cliente que contrata el servicio (o por su responsable legal, en caso de ser menor de edad)',
  'Try again': 'Intentar otra vez',
  'Try with a recent document': 'Intente con un documento reciente',
  'Try with selfie': 'Probá con selfie',
  'Try with document': 'Probá con documento',
  'Wait while we prepare the process':
    'Esperá mientras preparamos el proceso...',
  'Wait while we verify your identity':
    'Esperá mientras verificamos tu identidad',
  'We could not recognize you': 'No pudimos reconocerte',
  'We could not validate your face Follow these instructions and try again':
    'No fue posible validar tu rostro. Siga estas instrucciones y vuelva a intentarlo',
  'We need to verify your identity!': '¡Necesitamos verificar tu identidad!',
};
